function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("rect", {
  width: 92,
  height: 92,
  rx: 46,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.282 43.75c1.647 1.047 1.647 3.451 0 4.5l-21.7 13.808c-1.775 1.13-4.098-.145-4.098-2.25V32.191c0-2.105 2.323-3.38 4.099-2.25l21.7 13.809z",
  fill: "#333"
}));

function SvgButtonPlayRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTIiIGhlaWdodD0iOTIiIHZpZXdCb3g9IjAgMCA5MiA5MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHJlY3Qgd2lkdGg9IjkyIiBoZWlnaHQ9IjkyIiByeD0iNDYiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik02Mi4yODI0IDQzLjc0OTZDNjMuOTI5IDQ0Ljc5NzUgNjMuOTI5IDQ3LjIwMTMgNjIuMjgyNCA0OC4yNDkyTDQwLjU4MjcgNjIuMDU4QzM4LjgwNzUgNjMuMTg3NyAzNi40ODQ0IDYxLjkxMjUgMzYuNDg0NCA1OS44MDgzTDM2LjQ4NDQgMzIuMTkwNUMzNi40ODQ0IDMwLjA4NjMgMzguODA3NCAyOC44MTEgNDAuNTgyNyAyOS45NDA4TDYyLjI4MjQgNDMuNzQ5NloiIGZpbGw9IiMzMzMzMzMiLz4KPC9nPgo8L3N2Zz4K";
export { SvgButtonPlayRound as ReactComponent };